/* eslint-env browser */

(function (window) {
    'use strict';

    var STORAGE_KEY = 'siwa-personal-promo-seen';
    var EXPIRE_MS = 24 * 60 * 60 * 1000;
    var SHOW_DELAY_MS = 40000;

    var SKIP_PATHS = [
        '/siwa-personal',
        '/siwa-personal-onboarding',
        '/siwa-publisher',
        '/siwa-publisher-onboarding'
    ];

    function isVisitor() {
        return document.body && document.body.getAttribute('data-siwa-visitor') === '1';
    }

    function shouldSkipPath() {
        var path = window.location.pathname.replace(/\/$/, '') || '/';
        var i;
        for (i = 0; i < SKIP_PATHS.length; i += 1) {
            if (path === SKIP_PATHS[i] || path.indexOf(SKIP_PATHS[i] + '/') === 0) {
                return true;
            }
        }
        return false;
    }

    function promoExpired() {
        try {
            var raw = window.localStorage.getItem(STORAGE_KEY);
            if (!raw) {
                return true;
            }
            var seenAt = parseInt(raw, 10);
            if (isNaN(seenAt)) {
                return true;
            }
            return Date.now() - seenAt >= EXPIRE_MS;
        } catch (e) {
            return false;
        }
    }

    function markSeen() {
        try {
            window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch (e) {
            /* ignore */
        }
    }

    function getModal() {
        return document.getElementById('siwa-visitor-promo');
    }

    function openPromo() {
        var modal = getModal();
        if (!modal) {
            return;
        }
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('siwa-promo-lightbox-open');
    }

    function closePromo() {
        var modal = getModal();
        if (!modal) {
            return;
        }
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('siwa-promo-lightbox-open');
    }

    function bindEvents() {
        if (document.body.getAttribute('data-siwa-promo-bound') === '1') {
            return;
        }
        document.body.setAttribute('data-siwa-promo-bound', '1');

        document.addEventListener('click', function (event) {
            if (event.target.closest('[data-siwa-promo-close]')) {
                markSeen();
                closePromo();
            }
            if (event.target.closest('[data-siwa-promo-cta]')) {
                markSeen();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                var modal = getModal();
                if (modal && !modal.hidden) {
                    markSeen();
                    closePromo();
                }
            }
        });
    }

    function init() {
        if (!isVisitor() || shouldSkipPath() || !promoExpired()) {
            return;
        }

        var modal = getModal();
        if (!modal) {
            return;
        }

        bindEvents();

        window.setTimeout(function () {
            if (!promoExpired()) {
                return;
            }
            openPromo();
        }, SHOW_DELAY_MS);
    }

    window.SiwaVisitorPromo = {
        init: init,
        markSeen: markSeen
    };
})(window);
